import React from 'react';
import Icon from '../../../components/AppIcon';

const NotificationBanner = ({ notifications, onDismiss, onViewAll }) => {
  if (!notifications || notifications?.length === 0) return null;

  const getNotificationIcon = (type) => {
    switch (type) {
      case 'urgent':
        return 'AlertCircle';
      case 'appointment':
        return 'Calendar';
      case 'message':
        return 'Mail';
      case 'system':
        return 'Info';
      default:
        return 'Bell';
    }
  };

  const getNotificationColor = (type) => {
    switch (type) {
      case 'urgent':
        return 'bg-error/10 border-error/20 text-error';
      case 'appointment':
        return 'bg-primary/10 border-primary/20 text-primary';
      case 'message':
        return 'bg-accent/10 border-accent/20 text-accent';
      case 'system':
        return 'bg-warning/10 border-warning/20 text-warning';
      default:
        return 'bg-muted border-border text-foreground';
    }
  };

  return (
    <div className="space-y-2 mb-4">
      {notifications?.slice(0, 3)?.map((notification) => (
        <div
          key={notification?.id}
          className={`p-3 rounded-lg border-2 ${getNotificationColor(notification?.type)} flex items-start gap-3`}
        >
          <Icon name={getNotificationIcon(notification?.type)} size={20} className="flex-shrink-0 mt-0.5" />
          <div className="flex-1 min-w-0">
            <div className="flex items-start justify-between gap-2">
              <div className="flex-1">
                <h4 className="font-semibold text-sm mb-1">{notification?.title}</h4>
                <p className="text-sm opacity-90">{notification?.message}</p>
              </div>
              <button
                onClick={() => onDismiss(notification?.id)}
                className="flex-shrink-0 p-1 hover:bg-black/10 rounded transition-colors"
              >
                <Icon name="X" size={16} />
              </button>
            </div>
            <div className="flex items-center gap-3 mt-2 text-xs opacity-75">
              <span>{notification?.time}</span>
              {notification?.action && (
                <button className="font-medium underline hover:no-underline">
                  {notification?.action}
                </button>
              )}
            </div>
          </div>
        </div>
      ))}
      {notifications?.length > 3 && (
        <button
          onClick={onViewAll}
          className="w-full py-2 text-sm text-primary hover:underline font-medium"
        >
          Alle {notifications?.length} Benachrichtigungen anzeigen
        </button>
      )}
    </div>
  );
};

export default NotificationBanner;